import React, { useState, useEffect, useMemo, useLayoutEffect } from "react";

import FilterForm from "app/Components/FilterForm/FilterForm";
import {
  useArea,
  useCategory,
  useContractorDropdown,
  useContractorPerson,
  useEmployee,
} from "app/_helpers/hooks";
import { getAllActivity } from "app/_services/_globalConfiguration/Activity/ActivityService";
import { getAllSites } from "app/_services/ehs/ehsSiteServices";
//import { UserService } from "app/_services/UserService/UserService";
//import { LOGGED_IN_USER_SITE_ID } from "../../IncidentManagement/Helper";
import { userDropdownLabel } from "app/_helpers/helper";
import moment from "moment";
import {
  getAuthUser,
  LOGGED_IN_USER_SITE_ID,
} from "app/_pages/_healthSafetyEnvironment/IncidentManagement/Helper";
import { UserService } from "app/_services/UserService/UserService";
import {
  TRAINEE_TYPE,
  trainingScheduleFilterFields,
  trainingStatusFilterFields,
} from "../../CONSTANTS";

export default function TrainingScheduleFilters({ form, onChange, onReset, setForm }) {
  const [state, setState] = useState({
    sites: [],
  });

  const [category, categoryOption] = useCategory("filter[source]=training");
  const [subCategory, setSubCategory] = useState([]);
  const [contractors, contractorOption] = useContractorDropdown();
  const [vtoList, setVtoList] = useState([]);

  useEffect(() => {
    setSubCategory(
      category
        ?.find((d) => d.id === form?.trainingCategory)
        ?.subCategory?.map((obj) => ({ value: obj.id, label: obj.name })) || []
    );
  }, [category, form?.trainingCategory]);

  useEffect(() => {
    UserService.getUsers("filter[status]=1").then((response) => {
      if (!response?.data) return;
      const userSiteId = LOGGED_IN_USER_SITE_ID();
      const auth_user = getAuthUser();

      setVtoList(
        response.data
          .filter(
            (user) =>
              (user?.accessPermissions || []).filter(
                (d) => d.permission === "vto" && d.permissionValue === "1"
              ).length &&
              (+auth_user?.role?.roleLable === 1 ||
                +user?.employee?.ehsSite?.id === userSiteId)
          )
          .map((user) => ({
            label: userDropdownLabel(user),
            id: user.id,
            value: user.id,
          }))
      );
    });

    getAllSites("filter[status]=1").then((response) => {
      if (!response?.data) return;

      setState((prev) => ({
        ...prev,
        //initialActivity: response?.data,
        sites: response.data.map((row) => ({ label: row.name, value: row.id })),
      }));
    });
  }, []);

  const fields = useMemo(
    () =>
      trainingScheduleFilterFields.map((f) => {
        const field = { ...f };

        switch (field.name) {
          case "vtoId":
            field.options = vtoList;
            break;
          case "trainingCategory":
            field.options = categoryOption;
            break;
          case "trainingSubCategory":
            field.options = subCategory;
            break;
          case "siteId":
            field.options = state.sites;
            break;
          case "contractorId":
            field.options = contractorOption;
            break;
          default:
            break;
        }

        return field;
      }),
    [vtoList, categoryOption, subCategory, state.sites, contractorOption]
  );

  return (
    <div className="pb-4">
      <FilterForm fields={fields} form={form} onChange={onChange} onReset={onReset} />
    </div>
  );
}
